import { Tooltip } from '@chakra-ui/react';
import styles from './StatusCellRenderer.module.css';
import { Box, Text, Icon, VStack, HStack } from '@chakra-ui/react';
import Statuses from '../../utils/statuses';
import config from '@/config.json';
import { IoMdInformationCircleOutline } from 'react-icons/io';
import { toast } from 'react-toastify';

const StatusCellRenderer = ({
    value,
    noCircle,
    statusMessage,
    operatorStatus,
    operatorMessage,
    trunkName,
    parent = false,
}) => {
    // When parent status is OK (0), use trunkName as the label
    const isParentOk = parent && value === 0;
    const isDisabledTrunk =
        isParentOk &&
        (trunkName?.toLowerCase() === 'disabled' || trunkName === null);
    const effectiveValue = isDisabledTrunk ? 'disabled' : value;

    const operatorStatusTip =
        'Operator Status: ' + config.numbers.operatorStatusJSON[operatorStatus];

    const operatorMessageTip = 'Operator Message: ' + operatorMessage;

    const tooltipLabel =
        (Statuses[effectiveValue]?.toolTip
            ? Statuses[effectiveValue]?.toolTip
            : '') + (statusMessage ? `: ${statusMessage}` : '');

    const noMessage =
        operatorStatus == null &&
        !operatorMessage &&
        !statusMessage &&
        !Statuses[effectiveValue]?.toolTip;

    const copyContent = [
        tooltipLabel,
        operatorStatus != null && operatorStatusTip,
        operatorMessage && operatorMessageTip,
    ]
        .filter(Boolean)
        .join('\n');

    let displayName;
    if (isDisabledTrunk) {
        displayName = 'Disabled';
    } else if (isParentOk) {
        displayName = 'Active';
    } else {
        displayName = Statuses[value]?.displayedName;
    }

    return (
        <Tooltip
            hasArrow
            disabled={noMessage}
            portalProps={{ containerRef: undefined }}
            maxW="400px"
            width="auto"
            label={
                !noMessage && (
                    <Box display="flex" alignItems="left">
                        <VStack spacing="5px" align="start">
                            <Text textAlign="left" wordBreak="break-all">
                                {tooltipLabel}
                            </Text>
                            {operatorStatus != null && (
                                <HStack spacing={0} align="center">
                                    <Icon
                                        as={IoMdInformationCircleOutline}
                                        marginRight="5px"
                                        color="white"
                                    />
                                    <Text textAlign="left">
                                        {operatorStatusTip}
                                    </Text>
                                </HStack>
                            )}
                            {operatorMessage && (
                                <Text textAlign="left">
                                    {operatorMessageTip}
                                </Text>
                            )}
                        </VStack>
                    </Box>
                )
            }
            aria-label={Statuses[effectiveValue]?.toolTip}>
            <Box
                onClick={() => {
                    if (!noMessage) {
                        navigator.clipboard.writeText(copyContent);
                        toast.success('Copied to clipboard');
                    }
                }}
                cursor={!noMessage ? 'pointer' : 'default'}
                className={`${styles.tag} ${styles[Statuses[effectiveValue]?.type + 'Tag']}`}
                sx={{
                    display: 'flex',
                    alignItems: noCircle ? 'center' : null,
                    justifyContent: noCircle ? 'center' : null,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}>
                {!noCircle && (
                    <div
                        className={`${styles.circle} ${styles[Statuses[effectiveValue]?.type + 'Circle']}`}
                    />
                )}
                <Text isTruncated>{displayName}</Text>
            </Box>
        </Tooltip>
    );
};

export default StatusCellRenderer;
